import { ApiProperty } from "@nestjs/swagger";

export class StockTransferDto{
    @ApiProperty()
    transferType:string;
    @ApiProperty()
    stockIds:string[];
    @ApiProperty()
    saleOrderId?:number;
    @ApiProperty()
    saleOrderItemId?:number;
    @ApiProperty()
    toPlant?:number;
    @ApiProperty()
    zoneId?:number;
    @ApiProperty()
    rackPostion?:number;
    @ApiProperty()
    createdUser?:string;
    @ApiProperty()
    selectedRows?:any[];
}